import { Component, OnInit } from '@angular/core';
import { ToursService } from 'src/app/_services/tours.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Reservation } from 'src/app/_models/reservation';
import { DatePipe } from '@angular/common';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { ViajesService } from 'src/app/_services/viajes.service';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'app-tour-reservation',
  templateUrl: './tour-reservation.component.html',
  styleUrls: ['./tour-reservation.component.css'],
  providers: [NgbCarouselConfig]
})
export class TourReservationComponent implements OnInit {

  images = "assets/images/body/tour-detail-bg.jpg";
  images1 = "assets/images/body/tours/01.jpg";
  images2 = "assets/images/body/tours/02.jpg";
  imagenes: any[]=[];
  tourId;
  tourDetail;
  hotel;
  hotelStar:number[]=[];
  reservation: Reservation;
  allReservedSeat='';
  selectedSeats:string[]=[];
  bloqueado: number;
  habitacionesPrecio: any[]=[];
  submitted: boolean =  false;
  errorPasajeros: string = '';
  errorAsientos: string = '';
  errorHabitacion: string = '';
  errorCama: string = '';
  bloquear: boolean = false;
  constructor(private tourService: ToursService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private datePipe: DatePipe,
    config: NgbCarouselConfig,
    public accountService: AccountService) {
    const id: string = this.activeRoute.snapshot.paramMap.get('tourid');
		if (Number(id) > 0) {
			this.tourId = Number(id);
    }
    if(JSON.parse(localStorage.getItem("reservation"))){
      this.reservation= JSON.parse(localStorage.getItem("reservation"));
      if(this.reservation.id !== 0){        
        this.bloquear = true;
        this.bloqueado = -1; //señal para deshabilitar check de asientos
      }  
      else {
        this.bloquear = false;  
        this.bloqueado = 0;       
      }     
    }
    else{
      this.reservation= new Reservation();
    }
    

    config.showNavigationArrows = false;
    config.showNavigationIndicators = true;
    config.interval = 10000;
    config.animation = true;
   }

  ngOnInit(): void {
    this.loadImagen(this.tourId,0);
    this.loadTourDetail(this.tourId);
    //obtener resrvacion de la BD
  }


  loadImagen(idtour,imagenType){
    this.tourService.getImageByType(idtour,imagenType).subscribe(img=>{
      this.imagenes = img;
    });
  }
  loadTourDetail(idtour){
    this.tourService.getTourDetail(idtour).subscribe(tour=>{
      this.tourDetail = tour;                                         
      
      this.loadHotelByTour(this.tourDetail.id_hotel);
      this.loadReservation();
      this.allReservedSeat = this.tourDetail.asientos; //console.log('selected seats ' + this.allReservedSeat);
      this.loadReservedSeats(this.tourId);
      if(this.reservation.asientos !== ""){                             
        this.selectedSeats = this.reservation.asientos.split('*');       
      }
      
    });
  }
  loadHotelByTour(idohotel){
    this.tourService.getHotelByTour(idohotel).subscribe(hot=>{
            
      this.hotel = hot.data;
      this.fillStar(this.hotel.categoria_hotel);
      this.habitacionesPrecio = this.hotel.habitaciones.map(function(obj){
        var hab = {};
        hab['tipo'] = obj.tipo;
        hab['precio'] = obj.precio;
        hab['precioInic'] = obj.precio;
        return hab;
     });
     if( this.reservation.cuadruple > 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Cuadruple");
        if(index >=0)
          this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.cuadruple;
      }
      if( this.reservation.triple > 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Triple");
        if(index >=0)
          this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.triple;
      }
      if( this.reservation.doble > 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Doble");
        if(index >=0)
          this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.doble;
      }
      if( this.reservation.individual > 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Individual");
        if(index >=0)
          this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.individual;
      }   
    });
  }
  fillStar(numberStart){
    for (let index = 0; index < 5; index++) {
      if(index<numberStart){
        this.hotelStar.push(1);
      }
      else{
        this.hotelStar.push(0);
      }
    }
  }
  loadReservation(){
    this.reservation.paquete=this.tourDetail.id;
    
  }
  

  plusLessBaby(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.bebes+=1;
      }
      if(less && this.reservation.bebes!=0){
        this.reservation.bebes-=1;
      }
    }    
  }
  plusLessTeenger(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.menores+=1;
      }
      if(less && this.reservation.menores!=0){
        this.reservation.menores-=1;
      }
    }  
    //actualizar numero de pasajeros para asientos pendinte
    
  }

  plusLessAdult(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.adultos+=1;
      }
      if(less && this.reservation.adultos!=0){
        this.reservation.adultos-=1;
      }
    }    
    this.errorPasajeros ='';
    //actualizar numero de pasajeros para asientos pendiente    
  }
  plusLessMatrimonial(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.matrimonial+=1;
      }
      if(less && this.reservation.matrimonial!=0){
        this.reservation.matrimonial-=1;
      }
    }    
    this.errorCama ='';
  }
  plusLessTwin(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.twin+=1;
      }
      if(less && this.reservation.twin!=0){
        this.reservation.twin-=1;
      }
    }    
    this.errorCama ='';
  }
  plusLessCuadruple(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.cuadruple+=1;
      }
      if(less && this.reservation.cuadruple!=0){
        this.reservation.cuadruple-=1;
      }
      if( this.reservation.cuadruple >= 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Cuadruple");
        this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.cuadruple;
      }
    }    
    this.errorHabitacion='';
  }
  plusLessTripel(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.triple+=1;
      }
      if(less && this.reservation.triple!=0){
        this.reservation.triple-=1;
      }
      if( this.reservation.triple >= 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Triple");
        this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.triple;
      }
    }    
    this.errorHabitacion='';
  }
  plusLessDouble(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.doble+=1;
      }
      if(less && this.reservation.doble!=0){
        this.reservation.doble-=1;
      }
      if( this.reservation.doble >= 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Doble");
        this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.doble;
      }
    }    
    this.errorHabitacion='';
  }
  plusLessIndividual(plus,less){
    if(!this.bloquear){
      if(plus){
        this.reservation.individual+=1;
      }
      if(less && this.reservation.individual!=0){
        this.reservation.individual-=1;
      }
      if( this.reservation.individual >= 0){
        const index = this.habitacionesPrecio.findIndex(hab => hab.tipo === "Individual");
        this.habitacionesPrecio[index].precio = this.habitacionesPrecio[index].precioInic * this.reservation.individual;
      }    
    }    
    this.errorHabitacion='';
  }


  roomPriceDouble(){
    let doubleRoom='';
    if(this.hotel && this.hotel != 'undefined' && this.hotel != undefined){
      this.hotel.habitaciones.forEach(element => {
        if(element.tipo==='Doble'){
          doubleRoom = element.precio;
        }
      });
    }
    return doubleRoom;
  }
  roomPriceIndividual(){
    let individualRoom='';
    if(this.hotel){
      this.hotel.habitaciones.forEach(element => {
        if(element.tipo==='Individual'){
          individualRoom =  element.precio;
        }
      });
    }
    return individualRoom;
  }
  loadReservedSeats(idtour){
    this.tourService.getReservedSeats(idtour).subscribe(seats=>{
      //console.log(seats);
      seats.forEach(element => {
        //console.log(element.asientos_reservados);
        this.allReservedSeat+='*'+element.asientos_reservados;
      });
      //console.log(this.allReservedSeat);
    })
  }
  hasThisRoomType(roomType){
    let toReturn = false;
    if(this.hotel){
      this.hotel.habitaciones.forEach(element => {
        if(element.tipo===roomType){
          toReturn= true;
        }
      });
    }
    return toReturn;
  }
  hasErrorSeats(){
    var  totalPasajeros = this.reservation.adultos + this.reservation.menores; 
    if(!this.selectedSeats.length) {
      this.errorAsientos = 'Asientos es requerido';      
    }
    if(this.selectedSeats.length !== totalPasajeros) {  
      this.errorAsientos = 'El número de asientos seleccionados no se corresponde al número de pasajeros';      
    }  
    return (!this.selectedSeats.length || (this.selectedSeats.length !== totalPasajeros));
  }
  goReservation()
  {
    if(this.bloquear){
      this.router.navigate(['/','tours', 'tour-passangers' ,this.tourDetail.id]);
    }
    
    this.submitted = true;
        
    // stop here if form is invalid
    if(this.reservation.adultos === 0) {
      this.errorPasajeros = 'Cantidad de pasajeros adultos es requerido';      
    }
      
    var totalhabitaciones = this.reservation.individual + this.reservation.doble + this.reservation.triple + this.reservation.cuadruple;
    if(totalhabitaciones === 0){
      this.errorHabitacion = 'Cantidad de habitaciones es requerido';   
    }
    if((this.reservation.twin + this.reservation.matrimonial)===0){
      this.errorCama = 'Tipo de cama es requerido';
    }
    if(this.errorPasajeros !== '' || this.errorHabitacion !=='' || this.errorCama !== '' || this.hasErrorSeats()){
      return;
    }


    //continue if all ok
    this.reservation.asientos=''
    for (let index = 0; index < this.selectedSeats.length; index++) {
      if(index===this.selectedSeats.length-1){
        this.reservation.asientos+=this.selectedSeats[index];
      }
      else{
        this.reservation.asientos+=this.selectedSeats[index]+'*';
      }
    }
    this.reservation.user=parseInt(this.accountService.userValue.id);
    localStorage.setItem('reservation', JSON.stringify(this.reservation));
    this.router.navigate(['/','tours', 'tour-passangers' ,this.tourDetail.id]);
  }




}
